import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";

//Components
import AddWorkShift from "../Registration/WorkShift/addWorkShift";
import AltWorkShift from "../Registration/WorkShift/altWorkShift";
import DelWorkShift from "../Registration/WorkShift/delWorkShift";
import AltDays from "../Registration/WorkShift/altDays";
import Alert from "../../Components/alert/Alert";
import ReportWorkShifts from "../Reports/reportWorkShifts";

//Styles

import "./prelude.css";
import BottomBar from "../../Components/bottomBar/bottomBar";

import { handleColor } from "../../services/Functions";
import { DrawerMenu } from "../../Components/DrawerMenu/DrawerMenu";

const prelude_work_shift = () => {
  const [activeTab, setActiveTab] = React.useState("list");
  return (
    <>
      <header>
        <Top_bar />{" "}
      </header>
      <div className="prelude_container">
        <DrawerMenu>
          <Sidebar
            isMobile
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Sidebar>
        </DrawerMenu>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}></Sidebar>
      </div>
      <BottomBar></BottomBar>
    </>
  );
};

class Sidebar extends React.Component {
  state = { data: [], keys: [], render: false, message: "", click: false };

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const items = [
      { id: "lg1", label: "Turnos", eventKey: "list" },
      { id: "lg2", label: "Adicionar Turno", eventKey: "add" },
      { id: "lg3", label: "Alterar Turno", eventKey: "alt" },
      { id: "lg4", label: "Deletar Turno", eventKey: "del" },
      { id: "lg5", label: "Trocar Dia", eventKey: "altDays" },
    ];

    const { show, message } = this.state;

    return (
      <Tab.Container activeKey={this.props.activeTab}>
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1">
            <div
              className={this.props.isMobile ? "sidebar2-mobile" : "sidebar2"}
            >
              <Col className="sidebarColumn">
                <ListGroup>
                  {items.map((item) =>
                    this.props.isMobile ? (
                      <Col key={item.id} xs={12}>
                        <ListGroup.Item
                          id={item.id}
                          onClick={() => {
                            this.props.setActiveTab(item.eventKey);
                            this.props.handleClose();
                          }}
                          className="listGroup"
                          eventKey={item.eventKey}
                        >
                          {item.label}
                        </ListGroup.Item>
                      </Col>
                    ) : (
                      <ListGroup.Item
                        key={item.id}
                        id={item.id}
                        onClick={() => {
                          this.props.setActiveTab(item.eventKey);
                        }}
                        className="listGroup d-none d-md-block"
                        eventKey={item.eventKey}
                      >
                        {item.label}
                      </ListGroup.Item>
                    )
                  )}
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col2"
              style={{ top: "5%", width: "100%" }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              {!this.props.isMobile && (
                <Tab.Content>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="list">
                    {this.handleClick ? <ReportWorkShifts /> : null}
                  </Tab.Pane>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="add">
                    {this.handleClick ? <AddWorkShift /> : null}
                  </Tab.Pane>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="alt">
                    {this.handleClick ? <AltWorkShift /> : null}
                  </Tab.Pane>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="del">
                    {this.handleClick ? <DelWorkShift /> : null}
                  </Tab.Pane>
                  <Tab.Pane mountOnEnter unmountOnExit eventKey="altDays">
                    {this.handleClick ? <AltDays /> : null}
                  </Tab.Pane>
                </Tab.Content>
              )}
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_work_shift;
